<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="onSubmit">
                  <h1>Ingresar</h1>
                  <p class="text-muted">Bienvenido al CME</p>

                  <b-form-group label-for="email-usuario">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text class="border-visible">@</b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        id="email-usuario"
                        name="email-usuario"
                        type="email"
                        class="form-control"
                        placeholder="Correo Electrónico"
                        data-vv-as="Correo electrónico"
                        autocomplete="email"
                        v-validate="'required|email'"
                        v-model="form.email"
                        :state="validateState('email-usuario')"
                      />
                    </b-input-group>
                    <b-form-invalid-feedback :state="validateState('email-usuario')">
                      <span
                        v-for="error in errors.collect('email-usuario')"
                        :key="error"
                      >{{ error }}</span>
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-form-group label-for="contraseña-usuario">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text class="border-visible">
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input
                        id="contraseña-usuario"
                        name="contraseña-usuario"
                        type="password"
                        class="form-control"
                        placeholder="Contraseña"
                        data-vv-as="Contraseña"
                        autocomplete="new-password"
                        v-validate="'required'"
                        v-model="form.password"
                        :state="validateState('contraseña-usuario')"
                        ref="password"
                      />
                    </b-input-group>
                    <b-form-invalid-feedback :state="validateState('contraseña-usuario')">
                      <span
                        v-for="error in errors.collect('contraseña-usuario')"
                        :key="error"
                      >{{ error }}</span>
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <b-row>
                    <b-col cols="6">
                      <b-button
                        type="submit"
                        class="primary-btn-log"
                        block
                        :disabled="errors.any()"
                      >Iniciar Sesión</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button
                        variant="link"
                        class="px-0"
                        v-b-modal.modalRecover
                      >Olvidé mi Contraseña</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card
              v-if="isWeb"
              no-body
              class="text-white bg-primary py-5 d-md-down-none"
              style="width:44%"
            >
              <b-card-body class="text-center">
                <div>
                  <h2>Registrarse</h2>
                  <p>Registre Algunos datos para que pueda tener acceso a la comunidad CME.</p>
                  <b-button to="/register" variant="primary" class="active mt-3">¡Registrarse Ahora!</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <!--MODAL ENVIAR CORREO-->
    <b-modal id="modalRecover" title="Recuperar Contraseña" hide-footer>
      <b-col class="text-center mt-3">
        <b-form-group class="mb-3">
          <p>Ingrese el Correo con el que se Registró</p>
          <b-form-input
            id="recover-pass"
            name="recover-pass"
            type="email"
            placeholder="Correo Electrónico"
            data-vv-as="Recuperar contraseña"
            autocomplete="email"
            v-validate="'email'"
            :state="validateState('recover-pass')"
            v-model="recover.email"
          />
          <b-form-invalid-feedback :state="validateState('recover-pass')">
            <span v-for="error in errors.collect('recover-pass')" :key="error">{{ error }}</span>
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button type="submit" variant="primary" block v-on:click="sendEmail()">
          <strong>Enviar</strong>
        </b-button>
      </b-col>
    </b-modal>
    <!--Fin modal-->
  </div>
</template>

<script>
import { UserService, AuthenticationError } from "../../services/user.service";
import { TokenService } from "../../services/storage.service";
import { Promise } from "q";
export default {
  name: "Login",
  data() {
    return {
      isWeb: process.env.VUE_APP_IS_WEB,
      form: {},
      recover: {
        email: ""
      }
    };
  },
  methods: {
    onSubmit() {
      this.$validator
        .validateAll()
        .then(res => {
          if (res) {
            var promise = new Promise(res => {
              res(this.$store.dispatch("auth/login", this.form));
            });

            promise.then(_ => {
              let error = this.$store.getters["auth/authenticationErrorCode"];
              if (error) {
                if (error == 404) {
                  this.$swal({
                    type: "warning",
                    title: "¡No se Pudo Iniciar Sesión!",
                    text: "Correo Electrónico y/o Constraseña Incorrectos",
                    showConfirmButton: false,
                    timer: 3000
                  });
                } else if (error == 500) {
                  this.$swal({
                    type: "error",
                    title: "¡Error!",
                    text: "Ha Ocurrido un Error en la Base de Datos",
                    showConfirmButton: false,
                    timer: 3000
                  });
                }
              }
            });
          } else {
            this.$swal({
              type: "warning",
              title: "¡Campos Obligatorios!",
              text: "Completa los Campos Obligatorios",
              showConfirmButton: false,
              timer: 3000
            });
          }
        })
        .catch(err => console.log(err));
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    sendEmail() {
      promise.then(_ => {
        this.$validator
          .validateAll()
          .then(res => {
            if (res) {
              var promise = new Promise(res => {
                res(this.$store.dispatch("auth/recoverPass", this.recover));
              });

              promise.then(_ => {
                let error = this.$store.getters["auth/authenticationErrorCode"];
                if (error) {
                  if (error == 404) {
                    this.$swal({
                      type: "warning",
                      title: "¡No se pudo enviar correo!",
                      text: "Correo Electrónico Incorrecto o no Existente",
                      showConfirmButton: false,
                      timer: 3000
                    });
                  } else if (error == 500) {
                    this.$swal({
                      type: "error",
                      title: "¡Error!",
                      text: "Ocurrió un Error en la Base de Datos",
                      showConfirmButton: false,
                      timer: 3000
                    });
                  }
                }
              });
            } else {
              this.$swal({
                type: "warning",
                title: "¡Campos Obligatorios!",
                text: "Completa los Campos Obligatorios",
                showConfirmButton: false,
                timer: 3000
              });
            }
          })
          .catch(err => console.log(err));
      }); //verificar
    }
  }
};
</script>
<style scoped>
.primary-btn-log {
  background-color: #b38e5d !important;
  border-color: #b38e5d !important;
  color: #fff;
  font-weight: bold;
}

.primary-btn-log:hover {
  background-color: #b38e5d !important;
  border-color: #b38e5d !important;
}

.bg-primary {
  background-color: #285c4d !important;
  border-color: #1b3c34 !important;
  color: #ffffff;
  font-weight: bold;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #b38e5d;
  border-color: #b38e5d;  
}
.btn-primary:hover, .btn-primary:active, .btn-primary:focus{
      background-color: #b38e5d !important;
    border-color: #b38e5d !important;
}
</style>